module.exports = __webpack_public_path__ + "media/images/landing/icons/instagram-49a8e363784de2c595673c8dbd245010.svg";